// Modal cấu hình SỐ BÀI/GIỜ mỗi user (CTV) được đăng lên Kênh cộng đồng.
// Vượt số này -> API trả 429, user phải đợi hết giờ mới đăng tiếp.
import React, { useEffect, useState } from "react";
import { Modal, InputNumber, message, Alert } from "antd";
import communityApi from "../../../api/communityApi";

export default function CommunityPostLimitModal({ open, onClose }) {
    const [limit, setLimit] = useState(null);
    const [range, setRange] = useState({ min: 1, max: 500 });
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    // Mở modal -> tải giá trị hiện tại
    useEffect(() => {
        if (!open) return;
        (async () => {
            try {
                setLoading(true);
                const { data } = await communityApi.getPostLimit();
                const cfg = data?.data || {};
                setLimit(cfg.limit ?? null);
                setRange({ min: cfg.min ?? 1, max: cfg.max ?? 500 });
            } catch {
                message.error("Không thể tải cấu hình giới hạn đăng bài");
            } finally {
                setLoading(false);
            }
        })();
    }, [open]);

    const handleSave = async () => {
        if (!Number.isInteger(limit) || limit < range.min || limit > range.max) {
            message.error(`Vui lòng nhập số từ ${range.min} đến ${range.max}`);
            return;
        }
        try {
            setSaving(true);
            await communityApi.updatePostLimit(limit);
            message.success(`Đã lưu: tối đa ${limit} bài/giờ`);
            onClose();
        } catch {
            message.error("Không thể lưu cấu hình");
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal
            title="Giới hạn đăng bài (chống spam)"
            open={open}
            onOk={handleSave}
            onCancel={onClose}
            okText="Lưu"
            cancelText="Đóng"
            confirmLoading={saving}
        >
            <Alert
                type="info"
                showIcon
                className="mb-3"
                message="Số bài tối đa mỗi người dùng (CTV) được đăng lên Kênh cộng đồng trong 1 giờ. Vượt quá sẽ bị chặn tới khi hết giờ. Áp dụng sau khoảng 30 giây."
            />
            <InputNumber
                className="w-full"
                min={range.min}
                max={range.max}
                precision={0}
                value={limit}
                onChange={setLimit}
                disabled={loading}
                addonAfter="bài / giờ"
            />
        </Modal>
    );
}
